// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page .error-container {\n  margin: 0 auto;\n  padding: 12rem 6rem;\n  text-align: center;\n}\n.error-page .error-container img {\n  width: 9.5rem;\n  height: auto;\n  margin-bottom: 1rem;\n}\n.error-page .error-container h1 {\n  font-size: 3rem;\n  color: #FF4E35;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
